import React from 'react';
import { GoogleLogin, GoogleOAuthProvider } from '@react-oauth/google';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useAuth } from '../../contexts/AuthContext';

const GoogleOneTap = ({ setLoading, setError }) => {
  const { googleLogin } = useAuth();
  const navigate = useNavigate();

  const handleGoogleSuccess = async (credentialResponse) => {
    try {
      setLoading(true);
      setError('');

      const result = await googleLogin(credentialResponse.credential);

      if (result && result.success) {
        // Redirect based on user role
        if (result.user && result.user.role === 'admin') {
          navigate('/admin/dashboard', { replace: true });
        } else if (result.user && result.user.role === 'greeter') {
          navigate('/greeter/dashboard', { replace: true });
        } else {
          navigate('/user/dashboard', { replace: true });
        }
      } else {
        const msg = result?.message || 'Google authentication failed';
        setError(msg);
        toast.error(msg);
      }
    } catch (error) {
      console.error('Google auth error:', error);
      const msg = 'An error occurred during Google authentication. Please try again.';
      setError(msg);
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleError = () => {
    console.error('Google authentication failed');
    const msg = 'Google authentication failed. Please try again.';
    setError(msg);
    toast.error(msg);
  };

  return (
    <>
      <style>{`
        .google-button-wrapper {
          border-radius: 25px;
          overflow: hidden;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
          transition: all 0.3s ease;
          display: inline-block;
        }
        .google-button-wrapper:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
        }
        .google-button-wrapper:active {
          transform: translateY(0) scale(0.98);
        }
        .google-button-wrapper div[role="button"] {
          border-radius: 25px !important;
          transition: all 0.3s ease !important;
        }
        .google-button-wrapper:hover div[role="button"] {
          box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15) !important;
        }
        .google-button-wrapper:active div[role="button"] {
          transform: scale(0.98) !important;
        }
      `}</style>
      <div style={{ 
        width: '100%', 
        display: 'flex', 
        justifyContent: 'center' 
      }}>
        <div className="google-button-wrapper">
          <GoogleLogin
            onSuccess={handleGoogleSuccess}
            onError={handleGoogleError}
            theme="outline"
            shape="rectangular"
            text="continue_with"
            size="large"
          />
        </div>
      </div>
    </>
  );
};

const GoogleOneTapWrapper = (props) => {
  const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;

  if (!clientId) {
    console.warn('Google Client ID not configured');
    return null;
  }

  return (
    <GoogleOAuthProvider clientId={clientId}>
      <GoogleOneTap {...props} />
    </GoogleOAuthProvider>
  );
};

export default GoogleOneTapWrapper; 